var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2445 10.5786L11.5884 10.7121C11.0451 10.7319 10.6147 11.1782 10.6147 11.7219V15.2084M17.948 17.912L11.2231 11.2207",
    stroke: "#FCFDFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 22.6668C29.3333 20.1527 29.3333 18.8956 28.5522 18.1146C27.7712 17.3335 26.5141 17.3335 23.9999 17.3335H22.6666C20.1524 17.3335 18.8953 17.3335 18.1143 18.1146C17.3333 18.8956 17.3333 20.1527 17.3333 22.6668V24.0002C17.3333 26.5143 17.3333 27.7714 18.1143 28.5524C18.8953 29.3335 20.1524 29.3335 22.6666 29.3335H23.9999C26.5141 29.3335 27.7712 29.3335 28.5522 28.5524C29.3333 27.7714 29.3333 26.5143 29.3333 24.0002V22.6668Z",
    stroke: "#FCFDFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 11.3332V13.9998M13.3333 2.6665H18.6666M2.66659 18.6665V13.3332M13.9999 29.3332H11.3333M29.2534 7.33317C29.0481 5.9124 28.6486 4.90521 27.8716 4.12817C27.0945 3.35113 26.0874 2.95166 24.6666 2.74632M7.33325 2.74632C5.91245 2.95166 4.90525 3.35113 4.12832 4.12817C3.35125 4.90521 2.95179 5.9124 2.74645 7.33317M2.74645 24.6665C2.95179 26.0873 3.35125 27.0945 4.12832 27.8714C4.90525 28.6485 5.91245 29.048 7.33325 29.2533",
    stroke: "#FCFDFE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize_icon.0e319125db152c8a145d3ac3ced26896.svg";
export { ForwardRef as ReactComponent };